import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-medium transition-all duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 active:scale-[0.97] [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-[0_10px_30px_-18px_hsl(var(--shadow-color)/0.25)] hover:bg-primary/95 hover:shadow-[0_14px_34px_-18px_hsl(var(--shadow-color)/0.30)]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-[0_10px_30px_-18px_hsl(var(--shadow-color)/0.25)] hover:bg-destructive/90",
        outline:
          "border border-border bg-card text-foreground shadow-[0_6px_18px_-12px_hsl(var(--shadow-color)/0.22)] hover:bg-[hsl(var(--accent)/0.4)] hover:text-foreground",
        secondary:
          "border border-border bg-secondary text-secondary-foreground shadow-[0_6px_18px_-12px_hsl(var(--shadow-color)/0.22)] hover:bg-[hsl(var(--accent)/0.35)]",
        ghost: "text-primary hover:bg-[hsl(var(--accent)/0.35)] hover:text-primary",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 px-3 text-xs",
        lg: "h-11 px-5 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
